import { makeStyles } from "@material-ui/core";
import { fontWeight } from "@material-ui/system";

export const useStylesDark = makeStyles((theme) => ({
  wrapper: {
    justifyContent: "center",
  },
  paper: {
    width: "15%",
    margin: "2em",
    backgroundColor: "#141E27",
    [theme.breakpoints.down("md")]: {
      width: "22%",
    },
  },
  text: {
    marginTop: "0.3em",
    textAlign: "center",
    fontFamily: "Rubik",
    color: theme.palette.common.grey,
  },
  logoContainer: {},
  cvxLogo: {
    width: "3em",
    margin: "0.3em",
  },
  auctionsContainer: {
    textAlign: "center",
    justifyContent: "center",
    zIndex: 1000,
    alignItems: "center",
    align: "center",
  },
  auctionCard: {
    margin: "1em",
    marginBottom: "9.5em",
    marginTop: "-2.5em",
    zIndex: 1,
    width: "25em",
    background: "rgb(34 36 38)",
  },
  accountDetailsCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "1em",
    width: "40em",
    zIndex: 1,
    paddingTop: "0.6em",
    marginTop: "-4em",
    paddingBottom: "1em",
    background: "rgb(34 36 38)",

    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  userIncentivesAccordion: {
    marginBottom: "8em",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "12em",
    },
  },
  noActiveAuctionTitle: {
    fontSize: "1.5em",
    marginTop: "0.2em",
    color: "rgb(232, 230, 227)",
  },
  noActiveAuctionText: {
    fontSize: "1em",
    color: "grey",
  },
  claimsLoadingCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "1em auto",
    padding: "2em 1em",
    width: "30em",
    background: "rgb(34 36 38)",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  claimsLoadingSpinner: {
    color: "rgb(150 150 150)",
    marginBottom: "1em",
  },
  claimsLoadingText: {
    fontSize: "0.95em",
    color: "grey",
  },
  timeText: {
    fontSize: "1.3em",
    marginTop: "1.05em",
    color: "grey",
    textAlign: "center",
  },
  tab: {
    margin: "auto",
    display: "block",
    textAlign: "center",
  },
  uniSpace: {
    maxWidth: "15%",
    marginBottom: "-0.4em",
  },
  cvxSpace: {
    maxWidth: "15%",
  },
  crvSpace: {
    maxWidth: "8%",
    marginTop: "0.5em",
    marginBottom: "0.6em",
  },
  pagination: {
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  arrowButton: {
    color: "white",
  },
  votBox: {
    width: "3em",
    margin: "1em",
  },
  accordion: {
    width: "40em",
  },
  activeContainer: {
    alignItems: "center",
  },
  arrowsContainer: {
    marginBottom: "4em",
    marginTop: "-6em",
  },
  votTokenInput: {
    width: "2em",
  },
  claimContainer: {
    marginTop: "-10.5em",
    marginBottom: "4em",
  },
  submitButton: {
    textTransform: "none",
    fontFamily: "Rubik",
    fontSize: "1em",
    backgroundColor: "#141E27",
    color: theme.palette.common.lgrey,
  },
  submitButtonDisabled: {
    textTransform: "none",
    fontFamily: "Rubik",
    fontSize: "1em",
    background: "rgb(34 36 38)",
    color: "rgb(232, 230, 227) !important",
  },
  tableTextBottom: {
    borderBottom: "none",
  },
  orText: {
    color: "grey !important",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-25em",
  },
  modalPaper: {
    backgroundColor: "#070A0E",
    borderRadius: "3px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: "45em",
    width: "20em",
    alignItems: "center",
  },
  forwardModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-15em",
  },
  forwardModalPaper: {
    backgroundColor: "#070A0E",
    borderRadius: "3px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: "45em",
    width: "50em",
    alignItems: "center",
  },
  modalTitle: {
    fontSize: "1em",
    fontWeight: "700",
    marginTop: "-1em",
  },
  modalDelegateButton: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "50px",
    margin: "1em",
    background: "#141e27",
    borderRadius: "5px",
    color: theme.palette.common.grey,
    height: "3.7em",
  },
  modalDelegateButtonDisabled: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "50px",
    margin: "1em",
    background: "#cccecf",
    borderRadius: "5px",
    color: "white",
    height: "3.7em",
  },
  modalText: {
    textAlign: "center",
    margin: "1em",
    color: theme.palette.common.grey,
    fontWeight: "400",
  },
  modalClaimButton: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "70px",
    background: "#141E27",
    borderRadius: "5px",
    color: theme.palette.common.grey,
    height: "3em",
    padding: "1em",
    left: "35%",
    marginTop: "1.5em",
    marginBottom: "-0.1em",
  },
  modalClaimButtonDisabled: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "70px",
    background: "#cccecf",
    borderRadius: "5px",
    height: "3em",
    padding: "1em",
    left: "28%",
    marginTop: "1.5em",
    marginBottom: "-0.1em",
  },
  modalInput: {
    width: "30em",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgb(216 212 207)", // Change the border color to white (#fff)
      },
      "&:hover fieldset": {
        borderColor: "rgb(216 212 207)", // Change the border color to white (#fff) on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgb(216 212 207)", // Change the border color to white (#fff) when focused
      },
    },
  },
  delegateButton: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "50px",
    marginLeft: "0.75em",
    background: "#141E27",
    borderRadius: "5px",
    color: "white",
    height: "2.2em",
    padding: "0 0.85em",
  },
  delegateButtonDisabled: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "50px",
    marginLeft: "0.75em",
    background: "#141E27",
    borderRadius: "5px",
    color: "#BEBEBE !important",
    height: "2.2em",
    padding: "0 0.85em",
  },
  delegationStatusInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  faqButton: {
    color: theme.palette.common.grey,
    fontSize: "0.7em",
    textTransform: "none",
    background: "#141e27",
    margin: "1em",
  },
  unionManageButton: {
    color: "#fff",
    fontSize: "0.75em",
    textTransform: "none",
    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
    margin: "0 1em 1em",
    padding: "0.6em 1.5em",
    "&:hover": {
      background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
    },
  },
  infoIcon: {
    color: "grey",
    marginBottom: "-0.3em",
    zIndex: 100,
  },
  unconsumedDepositsText: { color: "white", margin: "1em" },
  infoTablePaper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "1em",
    width: "30em",
    zIndex: 1,
    marginTop: "-10em",
    background: "rgb(34 36 38)",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "12em",
    },
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  infoTable: {
    width: "100%",
    background: "rgb(34 36 38)",
    marginBottom: "1em",
  },
  tableText: { fontSize: "1em", color: "grey", fontWeight: "500" },
  tableSubText: {
    fontSize: "1em",
    color: "grey",
    fontWeight: "400",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
  },
  icon: { width: "1em", marginRight: "0.4em", marginBottom: "-0.1em" },
  snapshotIcon: {
    width: "1em",
    marginLeft: "0.4em",
    marginBottom: "-0.1em",
    color: "#f3b04e",
  },
  editButton: {
    cursor: "pointer",
    width: "0.7em",
    marginBottom: "-0.2em",
    marginLeft: "0.1em",
  },
  copyButton: { minWidth: "0.1em", color: "white" },
  optOutDialogPaper: {
    backgroundColor: "rgb(34 36 38)",
    fontFamily: "Rubik",
    borderRadius: "8px",
  },
  optOutDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.75em 1em 0.5em",
  },
  optOutDialogTitleText: {
    color: "rgb(206 205 203)",
    fontSize: "0.9em",
    fontWeight: 500,
  },
  optOutCloseButton: {
    color: "rgb(150 150 150)",
    padding: "0.35em",
  },
  optOutDialogContent: {
    padding: "0 1em 1.1em",
    color: "rgb(150 150 150)",
  },
  optOutBodyText: {
    color: "rgb(150 150 150)",
    fontSize: "0.9em",
    lineHeight: 1.55,
    marginBottom: "0.85em",
  },
  optOutHint: {
    color: "rgb(150 150 150)",
    fontSize: "0.82em",
    lineHeight: 1.5,
    marginBottom: "0.75em",
  },
  optOutGaugeLink: {
    background: "none",
    border: "none",
    color: "rgb(180 210 255)",
    cursor: "pointer",
    fontFamily: "Rubik",
    fontSize: "inherit",
    padding: 0,
    textDecoration: "underline",
  },
  optOutChip: {
    margin: "0.15em",
    background: "rgba(128, 128, 128, 0.18)",
    color: "rgb(206 205 203)",
    "& .MuiChip-deleteIcon": {
      color: "rgb(190, 190, 190)",
      "&:hover": {
        color: "rgb(230, 230, 230)",
      },
    },
  },
  optOutListbox: {
    backgroundColor: "rgb(34 36 38)",
  },
  optOutOption: {
    color: "rgb(206 205 203)",
    fontFamily: "Rubik",
    "&.Mui-selected": {
      backgroundColor: "rgba(93, 139, 208, 0.25)",
      color: "rgb(206 205 203)",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "rgba(93, 139, 208, 0.35)",
    },
  },
  optOutPopupIndicator: { color: "rgb(190, 190, 190)" },
  optOutClearIndicator: {
    color: "rgb(190, 190, 190)",
    "&:hover": {
      color: "rgb(230, 230, 230)",
    },
  },
  optOutInput: {
    width: "100%",
    margin: "0.25em 0 0.85em",
    "& .MuiOutlinedInput-root": {
      color: "rgb(206 205 203)",
      "& fieldset": {
        borderColor: "rgba(128, 128, 128, 0.45)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(128, 128, 128, 0.7)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(93, 139, 208, 0.7)",
      },
    },
    "& .MuiInputLabel-root": {
      color: "rgb(150 150 150)",
    },
  },
  optOutPrimaryButton: {
    background: "linear-gradient(45deg, #c0392b 30%, #922b21 90%)",
    color: "white",
    textTransform: "none",
    padding: "0.5em 1.25em",
    borderRadius: "6px",
    fontSize: "0.85em",
    fontWeight: 500,
    fontFamily: "Rubik",
    margin: "0.35em",
    "&:hover": {
      background: "linear-gradient(45deg, #e74c3c 30%, #c0392b 90%)",
    },
    "&:disabled": {
      background: "rgba(100, 100, 100, 0.3)",
      color: "rgba(206, 205, 203, 0.4)",
    },
  },
  optOutSecondaryButton: {
    background: "transparent",
    color: "rgb(190, 190, 190)",
    textTransform: "none",
    padding: "0.5em 1.25em",
    borderRadius: "4px",
    border: "1px solid grey",
    fontSize: "0.85em",
    fontWeight: 400,
    fontFamily: "Rubik",
    margin: "0.35em",
    "&:hover": {
      backgroundColor: "#313131",
    },
    "&:disabled": {
      color: "rgba(206, 205, 203, 0.35)",
      borderColor: "rgba(128, 128, 128, 0.35)",
    },
  },
  optOutActions: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    marginTop: "0.35em",
  },
  optOutSectionLabel: {
    color: "rgb(150 150 150)",
    fontSize: "0.82em",
    lineHeight: 1.5,
    margin: "1em 0 0.4em",
  },
  optOutList: {
    margin: "0 0 0.5em",
    padding: "0.35em 0.65em",
    border: "1px solid rgba(128, 128, 128, 0.45)",
    borderRadius: "4px",
    maxHeight: "180px",
    overflowY: "auto",
  },
  optOutListItem: {
    display: "flex",
    margin: 0,
    "& .MuiFormControlLabel-label": {
      fontSize: "0.85em",
      fontFamily: "Rubik",
      color: "rgb(206 205 203)",
    },
  },
  optOutCheckbox: {
    color: "rgb(170, 170, 170)",
    padding: "4px 8px 4px 0",
    "&.Mui-checked": {
      color: "rgb(210, 210, 210)",
    },
  },
  optOutMarketToggle: {
    display: "flex",
    gap: "0.4em",
    marginBottom: "0.9em",
  },
  optOutMarketButton: {
    flex: 1,
    textTransform: "none",
    fontFamily: "Rubik",
    fontSize: "0.82em",
    fontWeight: 500,
    borderRadius: "4px",
    border: "1px solid rgba(128, 128, 128, 0.45)",
    color: "rgb(150, 150, 150)",
    background: "transparent",
    padding: "0.35em 0.5em",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.04)",
    },
  },
  optOutMarketButtonSelected: {
    color: "rgb(232, 230, 227)",
    borderColor: "rgba(206, 205, 203, 0.7)",
    background: "rgba(206, 205, 203, 0.12)",
  },
}));

export const useStylesLight = makeStyles((theme) => ({
  wrapper: {
    justifyContent: "center",
  },
  paper: {
    width: "15%",
    margin: "2em",
    backgroundColor: "#141E27",
    [theme.breakpoints.down("md")]: {
      width: "22%",
    },
  },
  text: {
    marginTop: "0.3em",
    textAlign: "center",
    fontFamily: "Rubik",
    color: theme.palette.common.grey,
  },
  logoContainer: {},
  cvxLogo: {
    width: "3em",
    margin: "0.3em",
  },
  auctionsContainer: {
    textAlign: "center",
    justifyContent: "center",
    zIndex: 1000,
    alignItems: "center",
    align: "center",
  },
  auctionCard: {
    margin: "1em",
    marginBottom: "9.5em",
    marginTop: "-2.5em",
    zIndex: 1,
    width: "25em",
    background: "rgb(234 236 238)",
  },
  accountDetailsCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "1em",
    width: "40em",
    zIndex: 1,
    paddingTop: "0.6em",
    marginTop: "-4em",
    paddingBottom: "1em",
    background: "#e3e5e6",

    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  noActiveAuctionTitle: {
    fontSize: "1.5em",
    marginTop: "0.2em",
    color: "rgb(12, 10, 27)",
  },
  noActiveAuctionText: {
    fontSize: "1em",
    color: "rgb(32, 30, 37)",
  },
  timeText: {
    fontSize: "1.3em",
    marginTop: "1.05em",
    color: "grey",
    textAlign: "center",
  },
  tab: {
    margin: "auto",
    display: "block",
    textAlign: "center",
  },
  uniSpace: {
    maxWidth: "15%",
    marginBottom: "-0.4em",
  },
  cvxSpace: {
    maxWidth: "15%",
  },
  crvSpace: {
    maxWidth: "8%",
    marginTop: "0.5em",
    marginBottom: "0.6em",
  },
  pagination: {
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  arrowButton: {
    color: "white",
  },
  votBox: {
    width: "3em",
    margin: "1em",
  },
  accordion: {
    width: "40em",
  },
  activeContainer: {
    alignItems: "center",
  },
  arrowsContainer: {
    marginBottom: "4em",
    marginTop: "-6em",
  },
  votTokenInput: {
    width: "2em",
  },
  claimContainer: {
    marginTop: "-6em",
    marginBottom: "4em",
  },
  submitButton: {
    textTransform: "none",
    fontFamily: "Rubik",
    fontSize: "1em",
    backgroundColor: "#141E27",
    color: theme.palette.common.lgrey,
  },
  submitButtonDisabled: {
    textTransform: "none",
    fontFamily: "Rubik",
    fontSize: "1em",
    background: "rgb(34 36 38)",
    color: "rgb(232, 230, 227) !important",
  },
  tableTextBottom: {
    borderBottom: "none",
  },
  orText: {
    color: "grey !important",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-25em",
  },
  modalPaper: {
    backgroundColor: "#070A0E",
    borderRadius: "3px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: "45em",
    width: "20em",
    alignItems: "center",
  },
  forwardModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-15em",
  },
  forwardModalPaper: {
    backgroundColor: "#070A0E",
    borderRadius: "3px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: "45em",
    width: "50em",
    alignItems: "center",
  },
  modalTitle: {
    fontSize: "1em",
    fontWeight: "700",
    marginTop: "-1em",
  },
  modalDelegateButton: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "50px",
    margin: "1em",
    background: "#141e27",
    borderRadius: "5px",
    color: theme.palette.common.grey,
    height: "3.7em",
  },
  modalDelegateButtonDisabled: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "50px",
    margin: "1em",
    background: "#cccecf",
    borderRadius: "5px",
    color: "white",
    height: "3.7em",
  },
  modalText: {
    textAlign: "center",
    margin: "1em",
    color: theme.palette.common.grey,
    fontWeight: "400",
  },
  modalClaimButton: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "70px",
    background: "#141E27",
    borderRadius: "5px",
    color: theme.palette.common.grey,
    height: "3em",
    padding: "1em",
    left: "35%",
    marginTop: "1.5em",
    marginBottom: "-0.1em",
  },
  modalClaimButtonDisabled: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "70px",
    background: "#cccecf",
    borderRadius: "5px",
    height: "3em",
    padding: "1em",
    left: "28%",
    marginTop: "1.5em",
    marginBottom: "-0.1em",
  },
  modalInput: {
    width: "30em",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgb(216 212 207)", // Change the border color to white (#fff)
      },
      "&:hover fieldset": {
        borderColor: "rgb(216 212 207)", // Change the border color to white (#fff) on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgb(216 212 207)", // Change the border color to white (#fff) when focused
      },
    },
  },
  delegateButton: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "50px",
    marginLeft: "0.75em",
    background: "#141E27",
    borderRadius: "5px",
    color: "white",
    height: "2.2em",
    padding: "0 0.85em",
  },
  delegateButtonDisabled: {
    textTransform: "none",
    fontSize: "0.8em",
    fontFamily: "Rubik",
    minWidth: "50px",
    marginLeft: "0.75em",
    background: "#141E27",
    borderRadius: "5px",
    color: "#BEBEBE !important",
    height: "2.2em",
    padding: "0 0.85em",
  },
  delegationStatusInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  unconsumedDepositsText: { color: "white", margin: "1em" },
  faqButton: {
    color: theme.palette.common.grey,
    fontSize: "0.7em",
    textTransform: "none",
    background: "#141e27",
    margin: "1em",
  },
  unionManageButton: {
    color: "#fff",
    fontSize: "0.75em",
    textTransform: "none",
    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
    margin: "0 1em 1em",
    padding: "0.6em 1.5em",
    "&:hover": {
      background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
    },
  },
  infoIcon: {
    color: "grey",
    marginBottom: "-0.3em",
    zIndex: 100,
  },
  infoTablePaper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "1em",
    width: "30em",
    zIndex: 1,
    marginTop: "-10em",
    background: "rgb(34 36 38)",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "12em",
    },
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  infoTable: {
    width: "100%",
    marginBottom: "1em",
  },
  tableText: { fontSize: "1em", color: "grey", fontWeight: "500" },
  tableSubText: {
    fontSize: "1em",
    color: "grey",
    fontWeight: "400",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
  },
  icon: { width: "1em", marginRight: "0.4em", marginBottom: "-0.1em" },
  snapshotIcon: {
    width: "1em",
    marginLeft: "0.4em",
    marginBottom: "-0.1em",
    color: "#f3b04e",
  },
  editButton: {
    cursor: "pointer",
    width: "0.7em",
    marginBottom: "-0.2em",
    marginLeft: "0.1em",
  },
  copyButton: { minWidth: "0.1em", color: "white" },
  optOutDialogPaper: {
    backgroundColor: "#f5f5f5",
    fontFamily: "Rubik",
    borderRadius: "8px",
  },
  optOutDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.75em 1em 0.5em",
  },
  optOutDialogTitleText: {
    color: "#1a1a1a",
    fontSize: "0.9em",
    fontWeight: 500,
  },
  optOutCloseButton: {
    color: "#888",
    padding: "0.35em",
  },
  optOutDialogContent: {
    padding: "0 1em 1.1em",
    color: "#555",
  },
  optOutBodyText: {
    color: "#555",
    fontSize: "0.9em",
    lineHeight: 1.55,
    marginBottom: "0.85em",
  },
  optOutHint: {
    color: "#555",
    fontSize: "0.82em",
    lineHeight: 1.5,
    marginBottom: "0.75em",
  },
  optOutGaugeLink: {
    background: "none",
    border: "none",
    color: "#2c6fad",
    cursor: "pointer",
    fontFamily: "Rubik",
    fontSize: "inherit",
    padding: 0,
    textDecoration: "underline",
  },
  optOutChip: {
    margin: "0.15em",
    background: "rgba(44, 111, 173, 0.1)",
    color: "#1a1a1a",
    "& .MuiChip-deleteIcon": {
      color: "#666",
      "&:hover": {
        color: "#333",
      },
    },
  },
  optOutListbox: {
    backgroundColor: "#f5f5f5",
  },
  optOutOption: {
    color: "#1a1a1a",
    fontFamily: "Rubik",
    "&.Mui-selected": {
      backgroundColor: "rgba(44, 111, 173, 0.12)",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "rgba(44, 111, 173, 0.2)",
    },
  },
  optOutPopupIndicator: { color: "#888" },
  optOutClearIndicator: {
    color: "#666",
    "&:hover": {
      color: "#333",
    },
  },
  optOutInput: {
    width: "100%",
    margin: "0.25em 0 0.85em",
    "& .MuiOutlinedInput-root": {
      color: "#1a1a1a",
      "& fieldset": {
        borderColor: "rgba(0, 0, 0, 0.23)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(0, 0, 0, 0.4)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#2c6fad",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#555",
    },
  },
  optOutPrimaryButton: {
    background: "linear-gradient(45deg, #c0392b 30%, #922b21 90%)",
    color: "white",
    textTransform: "none",
    padding: "0.5em 1.25em",
    borderRadius: "6px",
    fontSize: "0.85em",
    fontWeight: 500,
    fontFamily: "Rubik",
    margin: "0.35em",
    "&:hover": {
      background: "linear-gradient(45deg, #e74c3c 30%, #c0392b 90%)",
    },
    "&:disabled": {
      background: "rgba(100, 100, 100, 0.2)",
      color: "rgba(0, 0, 0, 0.3)",
    },
  },
  optOutSecondaryButton: {
    background: "transparent",
    color: "#555",
    textTransform: "none",
    padding: "0.5em 1.25em",
    borderRadius: "4px",
    border: "1px solid #aaa",
    fontSize: "0.85em",
    fontWeight: 400,
    fontFamily: "Rubik",
    margin: "0.35em",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.3)",
      borderColor: "rgba(0, 0, 0, 0.15)",
    },
  },
  optOutActions: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    marginTop: "0.35em",
  },
  optOutSectionLabel: {
    color: "#555",
    fontSize: "0.82em",
    lineHeight: 1.5,
    margin: "1em 0 0.4em",
  },
  optOutList: {
    margin: "0 0 0.5em",
    padding: "0.35em 0.65em",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    maxHeight: "180px",
    overflowY: "auto",
  },
  optOutListItem: {
    display: "flex",
    margin: 0,
    "& .MuiFormControlLabel-label": {
      fontSize: "0.85em",
      fontFamily: "Rubik",
      color: "#1a1a1a",
    },
  },
  optOutCheckbox: {
    color: "#777",
    padding: "4px 8px 4px 0",
    "&.Mui-checked": {
      color: "#555",
    },
  },
  optOutMarketToggle: {
    display: "flex",
    gap: "0.4em",
    marginBottom: "0.9em",
  },
  optOutMarketButton: {
    flex: 1,
    textTransform: "none",
    fontFamily: "Rubik",
    fontSize: "0.82em",
    fontWeight: 500,
    borderRadius: "4px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    color: "#555",
    background: "transparent",
    padding: "0.35em 0.5em",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  optOutMarketButtonSelected: {
    color: "#1a1a1a",
    borderColor: "#1a1a1a",
    background: "rgba(0, 0, 0, 0.06)",
  },
  userIncentivesAccordion: {
    marginBottom: "8em",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "12em",
    },
  },
}));
